export const formatEnvironmentTitle = (envString?: string) =>
	envString ? `${envString} ` : ``;
